import React, { useState } from "react";
import { Alert, Form, Snackbar } from "../../../../layout";
import { Divider, Grid, Paper } from "@mui/material";

import { Model, UseForm } from "../../../../hooks";
import Header from "./Header";
import ReturnFields from "./ReturnFields";
import ReturnItems from "./ReturnItems";

const StockReturnForm = () => {
  const { StockReturnMdl } = Model();
  const [stockDetails, setStockDetails] = useState({});
  const {
    values,
    setValues,
    setErrors,
    handleInpChg,
    handleInpDate,
    handleInpCheck,
  } = UseForm(StockReturnMdl);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const [snackbar, setSnackbar] = useState({
    show: false,
    msg: "",
    type: "success",
  });

  const handleClear = () => {
    setValues((j) => ({
      ...StockReturnMdl(),
      orderNo: j.orderNo,
    }));
  };

  return (
    <>
      <Form noValidate>
        <Paper className="shadow-sm">
          {/* ------- Top Header ------- */}
          <Header {...{ setErrors, values, setAlert }} />
          <Divider />
          <div className="p-[10px] mt-[10px]">
            <Grid container spacing={2}>
              {/* ------- Text Fields ------- */}
              <ReturnFields
                {...{
                  setValues,
                  stockDetails,
                  setStockDetails,
                  handleClear,
                  values,
                  handleInpChg,
                  handleInpDate,
                  handleInpCheck,
                }}
              />
              {/* ------- Return Items ------- */}
              <ReturnItems
                {...{ values, setValues, stockDetails, setStockDetails }}
              />
            </Grid>
          </div>
        </Paper>
      </Form>

      <Snackbar {...{ snackbar, setSnackbar }} />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default StockReturnForm;
